export const convertStrToSlug = (str) => str.toLowerCase().replace(/\s+/g, "-");

export const fetchJSON = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Failed to fetch from ${url}`);
    return await response.json();
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const updateUrlParam = (urlParam, paramValue) => {
  const url = new URL(window.location.href);
  url.searchParams.set(urlParam, paramValue);
  window.history.replaceState({}, "", url); // no reload
};
